import { render, staticRenderFns } from "./EditFormWysiwyg.vue?vue&type=template&id=b1a0ae9c"
import script from "./EditFormWysiwyg.vue?vue&type=script&lang=js"
export * from "./EditFormWysiwyg.vue?vue&type=script&lang=js"
import style0 from "./EditFormWysiwyg.vue?vue&type=style&index=0&id=b1a0ae9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports